module.exports = __webpack_public_path__ + "img/green_circle.7b0565c1.png";